export default {
    paths: {
        home: "/",
        session: id => `/session/${id}`,
        devResources: (path = "") => `/dev-resources${path}`,
        notFound: "/404",
        callback: "/callback",
    },
};
